module.exports = __webpack_public_path__ + "img/hamza1.32b91430.png";